/* AgentMeeting — Pricing page */

import React from 'react';
import { MarketingBar, MarketingFooter } from '../shared/marketing-bar';

export function Pricing({ goTo }) {
  const [billing, setBilling] = React.useState('monthly');  // monthly | yearly
  const [apiMode, setApiMode] = React.useState('managed');   // managed | byok

  const tiers = [
    {
      id: 'hobby',
      name: 'Hobby',
      tag: '个人玩家',
      tagline: '$0 永远免费 · 周末试试看',
      priceM: 0, priceY: 0,
      cta: 'start free',
      ctaPrimary: false,
      features: [
        { ok: true, t: '每月 50 分钟会议时长' },
        { ok: true, t: '同时最多 4 个 agent 在场' },
        { ok: true, t: '6 个内置 agent · 不能 clone' },
        { ok: true, t: '本地 Llama-4 模式 (BYOM)' },
        { ok: false, t: '托管 LLM (Claude / GPT-4o)' },
        { ok: false, t: 'Replay 时间机器 / Fork' },
        { ok: false, t: '会议纪要 PDF / Notion 导出' },
      ],
    },
    {
      id: 'pro',
      name: 'Pro',
      tag: '推荐',
      tagline: '一个人决策的最佳搭子',
      priceM: 29, priceY: 24,
      cta: 'start 14-day trial',
      ctaPrimary: true,
      highlighted: true,
      features: [
        { ok: true, t: '每月 1500 分钟 · 超额 $0.04/min' },
        { ok: true, t: '$30 LLM credits included (Managed)' },
        { ok: true, t: '同时最多 8 个 agent' },
        { ok: true, t: '自定义 agent · clone & 改 system prompt' },
        { ok: true, t: 'Replay / Fork / 时间线分支' },
        { ok: true, t: '导出 Markdown / PDF / Notion / Linear' },
        { ok: false, t: 'Workspace · 多人协作 / 共享班子' },
      ],
    },
    {
      id: 'team',
      name: 'Team',
      tag: '团队',
      tagline: '5 个人共享 agent 库与会议室',
      priceM: 99, priceY: 79,
      perSeat: true,
      cta: 'contact sales',
      ctaPrimary: false,
      features: [
        { ok: true, t: 'Pro 全部功能' },
        { ok: true, t: '每席位 2000 分钟 / 月 (可池化)' },
        { ok: true, t: '$50 LLM credits / seat included' },
        { ok: true, t: 'Workspace · 团队共享 agent 库' },
        { ok: true, t: 'SSO (SAML / Google Workspace)' },
        { ok: true, t: '审计日志 / 权限粒度控制' },
        { ok: true, t: '优先支持 · SLA 99.5%' },
      ],
    },
    {
      id: 'enterprise',
      name: 'Enterprise',
      tag: '企业 / 政府',
      tagline: '自部署 · 数据驻留 · 合规审计',
      priceM: null, priceY: null,
      cta: 'talk to us',
      ctaPrimary: false,
      features: [
        { ok: true, t: 'Team 全部功能' },
        { ok: true, t: '私有化 / VPC 部署' },
        { ok: true, t: '自带 LLM 网关 / Bedrock / Azure OpenAI' },
        { ok: true, t: 'SOC2 Type II · ISO 27001 · GDPR' },
        { ok: true, t: '专属 CSM · 季度模型微调' },
        { ok: true, t: '法务 / MSA / DPA 自定义' },
        { ok: true, t: 'SLA 99.95% · 7×24 on-call' },
      ],
    },
  ];

  return (
    <div className="mkt-page">
      <MarketingBar here="pricing" goTo={goTo} />

      <section style={{ padding: '64px 24px 32px', textAlign: 'center', borderBottom: '1px solid var(--line-1)' }}>
        <span className="mono tiny" style={{ color: 'var(--live)', letterSpacing: '0.16em' }}>
          [PRICING]
        </span>
        <h1 style={{
          fontSize: 56, fontWeight: 500, letterSpacing: '-0.02em',
          margin: '16px 0 12px', lineHeight: 1.05,
        }}>
          按 <span style={{ color: 'var(--live)' }}>会议时长</span> 收钱,<br />
          不按 <span className="dim">"席位"</span> 收钱
        </h1>
        <p style={{ color: 'var(--fg-1)', fontSize: 16, maxWidth: 580, margin: '0 auto', lineHeight: 1.6 }}>
          Agent 不收人头费,你只为它们真的在思考的分钟数付钱。
          <br />Token 成本透明转嫁,我们不在中间加 2x markup。
        </p>

        {/* billing toggle */}
        <div className="flex center" style={{
          justifyContent: 'center', gap: 8, marginTop: 32,
        }}>
          <div style={{
            display: 'inline-flex', padding: 4,
            border: '1px solid var(--line-2)', borderRadius: 6,
            background: 'var(--bg-1)',
          }}>
            {['monthly', 'yearly'].map(b => (
              <button key={b}
                className={'mono tiny ' + (billing === b ? 'active' : '')}
                onClick={() => setBilling(b)}
                style={{
                  padding: '8px 18px', borderRadius: 4,
                  background: billing === b ? 'var(--bg-3)' : 'transparent',
                  color: billing === b ? 'var(--fg-0)' : 'var(--fg-2)',
                  border: 'none', cursor: 'pointer',
                  fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.08em',
                }}>
                {b.toUpperCase()}
                {b === 'yearly' && (
                  <span style={{
                    marginLeft: 8, padding: '2px 6px',
                    background: 'var(--live)', color: 'var(--bg-0)',
                    borderRadius: 3, fontSize: 9,
                  }}>−17%</span>
                )}
              </button>
            ))}
          </div>
          <span className="dim mono tiny" style={{ marginLeft: 16 }}>·</span>
          <div style={{
            display: 'inline-flex', padding: 4, marginLeft: 8,
            border: '1px solid var(--line-2)', borderRadius: 6,
            background: 'var(--bg-1)',
          }}>
            {[['managed', '托管 LLM'], ['byok', 'BYOK']].map(([id, lbl]) => (
              <button key={id} onClick={() => setApiMode(id)}
                style={{
                  padding: '8px 14px', borderRadius: 4,
                  background: apiMode === id ? 'var(--bg-3)' : 'transparent',
                  color: apiMode === id ? 'var(--fg-0)' : 'var(--fg-2)',
                  border: 'none', cursor: 'pointer',
                  fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.08em',
                }}>
                {lbl}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* tier grid */}
      <section style={{ padding: '40px 24px', maxWidth: 1280, margin: '0 auto' }}>
        <div className="grid-4">
          {tiers.map(t => (
            <PricingCard key={t.id} tier={t} billing={billing} goTo={goTo} />
          ))}
        </div>
      </section>

      {/* token-cost transparency */}
      <section style={{
        padding: '48px 24px', borderTop: '1px solid var(--line-1)',
        borderBottom: '1px solid var(--line-1)', background: 'var(--bg-1)',
      }}>
        <div style={{ maxWidth: 1080, margin: '0 auto' }}>
          <div className="flex between" style={{ marginBottom: 24, alignItems: 'flex-end' }}>
            <div>
              <span className="mono tiny" style={{ color: 'var(--live)', letterSpacing: '0.12em' }}>
                [TOKEN COSTS · TRANSPARENT]
              </span>
              <h2 style={{ fontSize: 28, fontWeight: 500, margin: '8px 0 4px', letterSpacing: '-0.02em' }}>
                你的会到底花了多少钱?
              </h2>
              <p className="meta" style={{ margin: 0 }}>
                我们不藏 markup。一场标准 6 人 30 分钟的会, 平均花 $0.40 ~ $1.20 LLM credits。
              </p>
            </div>
            <span className="mono tiny dim">updated weekly · 2025-Q1 公开费率</span>
          </div>

          <div style={{
            border: '1px solid var(--line-2)', borderRadius: 6,
            overflow: 'hidden', background: 'var(--bg-0)',
          }}>
            <div className="grid" style={{
              gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
              padding: '12px 16px', borderBottom: '1px solid var(--line-1)',
              background: 'var(--bg-2)',
              fontFamily: 'var(--mono)', fontSize: 11,
              color: 'var(--fg-2)', letterSpacing: '0.06em',
            }}>
              <div>MODEL</div>
              <div>INPUT $/M</div>
              <div>OUTPUT $/M</div>
              <div>SPEED</div>
              <div>30min mtg avg</div>
            </div>
            {[
              ['Claude Sonnet 4.5', 3.00, 15.00, 'medium', '$0.62', true],
              ['Claude Haiku 4.5', 1.00, 5.00, 'fast', '$0.21', false],
              ['GPT-4o', 2.50, 10.00, 'medium', '$0.48', false],
              ['GPT-4o-mini', 0.15, 0.60, 'fast', '$0.04', false],
              ['Gemini 2.5 Pro', 1.25, 10.00, 'medium', '$0.39', false],
              ['Llama-4 (本地)', 0, 0, 'depends', '$0.00', false],
            ].map(([m, inp, out, sp, avg, def], i) => (
              <div key={i} className="grid" style={{
                gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
                padding: '12px 16px',
                borderBottom: i < 5 ? '1px solid var(--line-1)' : 'none',
                fontFamily: 'var(--mono)', fontSize: 12,
                background: def ? 'var(--bg-2)' : 'transparent',
              }}>
                <div className="flex center gap-2">
                  <span>{m}</span>
                  {def && <span className="tag mono tiny" style={{
                    borderColor: 'var(--live)', color: 'var(--live)',
                  }}>default</span>}
                </div>
                <div className="dim">${inp.toFixed(2)}</div>
                <div className="dim">${out.toFixed(2)}</div>
                <div className="dim">{sp}</div>
                <div style={{ color: 'var(--live)' }}>{avg}</div>
              </div>
            ))}
          </div>

          <div className="meta" style={{ marginTop: 16, textAlign: 'center', fontSize: 12 }}>
            托管模式: 这些价格 + 0% markup, 我们用前端 token 计数实时计费 ·
            BYOK 模式: 用你的 API key, 我们一分钱不收 token 费, 只收 $5/月 平台费
          </div>
        </div>
      </section>

      {/* feature comparison */}
      <section style={{ padding: '48px 24px', maxWidth: 1080, margin: '0 auto' }}>
        <div style={{ marginBottom: 24 }}>
          <span className="mono tiny" style={{ color: 'var(--live)', letterSpacing: '0.12em' }}>
            [FULL COMPARISON]
          </span>
          <h2 style={{ fontSize: 28, fontWeight: 500, margin: '8px 0 0', letterSpacing: '-0.02em' }}>
            细到指甲盖儿的功能对比
          </h2>
        </div>
        <ComparisonTable />
      </section>

      {/* faq */}
      <section style={{
        padding: '48px 24px', maxWidth: 880, margin: '0 auto',
      }}>
        <div style={{ marginBottom: 24 }}>
          <span className="mono tiny" style={{ color: 'var(--live)', letterSpacing: '0.12em' }}>
            [FAQ]
          </span>
          <h2 style={{ fontSize: 28, fontWeight: 500, margin: '8px 0 0', letterSpacing: '-0.02em' }}>
            常见疑问
          </h2>
        </div>
        <FaqList />
      </section>

      {/* bottom cta */}
      <section style={{
        padding: '64px 24px', borderTop: '1px solid var(--line-1)',
        background: 'var(--bg-1)', textAlign: 'center',
      }}>
        <h2 style={{
          fontSize: 36, fontWeight: 500, letterSpacing: '-0.02em',
          margin: '0 0 12px',
        }}>
          先开一场, 再决定要不要付钱
        </h2>
        <p style={{ color: 'var(--fg-1)', margin: '0 0 24px', fontSize: 15 }}>
          注册送 $5 LLM credits · 大约够开 5 ~ 10 场会
        </p>
        <div className="flex center" style={{ justifyContent: 'center', gap: 12 }}>
          <button className="btn-lg primary mono" onClick={() => goTo('signup')}>
            $ start free →
          </button>
          <button className="btn-lg ghost mono" onClick={() => goTo('app/agenda')}>
            see it run first
          </button>
        </div>
      </section>

      <MarketingFooter goTo={goTo} />
    </div>
  );
}

function PricingCard({ tier, billing, goTo }) {
  const price = billing === 'yearly' ? tier.priceY : tier.priceM;
  const hi = tier.highlighted;
  return (
    <div style={{
      position: 'relative',
      border: '1px solid ' + (hi ? 'var(--live)' : 'var(--line-2)'),
      borderRadius: 8,
      padding: 24,
      background: hi ? 'var(--bg-1)' : 'var(--bg-0)',
      display: 'flex', flexDirection: 'column',
      boxShadow: hi ? '0 0 24px var(--live-dim)' : 'none',
    }}>
      {hi && (
        <div style={{
          position: 'absolute', top: -10, left: 24,
          padding: '3px 10px',
          background: 'var(--live)', color: 'var(--bg-0)',
          fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: '0.1em',
          borderRadius: 3,
        }}>RECOMMENDED</div>
      )}

      <div className="flex between center" style={{ marginBottom: 8 }}>
        <span style={{ fontSize: 20, fontWeight: 500 }}>{tier.name}</span>
        <span className="mono tiny dim">{tier.tag}</span>
      </div>
      <p className="meta" style={{ margin: '0 0 16px', fontSize: 12, minHeight: 32 }}>
        {tier.tagline}
      </p>

      <div style={{ minHeight: 64, marginBottom: 16 }}>
        {price === null ? (
          <div>
            <span style={{ fontSize: 28, fontWeight: 500, letterSpacing: '-0.02em' }}>
              聊一聊
            </span>
            <div className="meta" style={{ fontSize: 11 }}>按部署规模定价</div>
          </div>
        ) : (
          <div>
            <span style={{ fontSize: 36, fontWeight: 500, letterSpacing: '-0.02em' }}>
              ${price}
            </span>
            <span className="mono tiny dim" style={{ marginLeft: 6 }}>
              /mo{tier.perSeat ? ' /seat' : ''}
            </span>
            {billing === 'yearly' && tier.priceM > 0 && (
              <div className="meta" style={{ fontSize: 11, textDecoration: 'line-through' }}>
                ${tier.priceM}/mo monthly
              </div>
            )}
          </div>
        )}
      </div>

      <button className={'btn-lg mono ' + (tier.ctaPrimary ? 'primary' : 'ghost')}
        onClick={() => goTo(tier.id === 'enterprise' ? 'pricing' : 'signup')}
        style={{ marginBottom: 20, width: '100%' }}>
        {tier.cta} →
      </button>

      <div className="col gap-2" style={{ flex: 1 }}>
        {tier.features.map((f, i) => (
          <div key={i} className="flex gap-2" style={{ fontSize: 13, alignItems: 'flex-start' }}>
            <span className="mono" style={{
              color: f.ok ? 'var(--live)' : 'var(--fg-3)',
              fontSize: 12, marginTop: 2,
            }}>{f.ok ? '✓' : '×'}</span>
            <span style={{
              color: f.ok ? 'var(--fg-1)' : 'var(--fg-3)',
              textDecoration: f.ok ? 'none' : 'line-through',
              lineHeight: 1.4,
            }}>{f.t}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function ComparisonTable() {
  const rows = [
    ['CORE', null],
    ['每月会议时长', '50min', '1500min', '2000min /seat', '无限'],
    ['同时在场 agent', '4', '8', '12', '无限'],
    ['内置 agent', '6 个', '6 个', '6 个', '6 个 + 自定义集'],
    ['自定义 agent', '×', '✓', '✓ (共享)', '✓ (共享 + 私有)'],
    ['LLM 模型选择', 'Llama 本地', '全部', '全部', '全部 + 自部署'],
    ['POWER', null],
    ['Replay 时间机器', '×', '✓', '✓', '✓'],
    ['Fork 平行剧情', '×', '✓ (3 分支)', '✓ (无限)', '✓ (无限)'],
    ['插话 / 暂停', '✓', '✓', '✓', '✓'],
    ['会议纪要导出', 'TXT', 'MD / PDF', 'MD / PDF / Notion / Linear', '全部 + Webhook'],
    ['COLLAB', null],
    ['Workspace', '×', '×', '✓ (5 seats)', '✓ (无限)'],
    ['共享 agent 库', '×', '×', '✓', '✓'],
    ['共享会议室 (实时)', '×', '×', '✓', '✓'],
    ['SECURITY', null],
    ['SSO (SAML / OIDC)', '×', '×', '✓', '✓'],
    ['SOC 2 / ISO 27001', '×', '×', '✓', '✓ + DPA'],
    ['数据驻留区', 'US', 'US / EU', 'US / EU / SG', '自定义'],
    ['私有化部署', '×', '×', '×', '✓'],
    ['SUPPORT', null],
    ['响应时间', '社区', '< 24h', '< 4h', '< 1h · 7×24'],
    ['专属 CSM', '×', '×', '×', '✓'],
  ];

  return (
    <div style={{
      border: '1px solid var(--line-2)', borderRadius: 6,
      overflow: 'hidden', background: 'var(--bg-0)',
    }}>
      <div className="grid" style={{
        gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
        padding: '14px 16px', background: 'var(--bg-2)',
        borderBottom: '1px solid var(--line-1)',
        fontFamily: 'var(--mono)', fontSize: 11,
        color: 'var(--fg-2)', letterSpacing: '0.08em',
      }}>
        <div>FEATURE</div>
        <div>HOBBY</div>
        <div style={{ color: 'var(--live)' }}>PRO</div>
        <div>TEAM</div>
        <div>ENTERPRISE</div>
      </div>
      {rows.map((r, i) => {
        if (r[1] === null) {
          return (
            <div key={i} style={{
              padding: '10px 16px',
              background: 'var(--bg-1)',
              borderTop: i > 0 ? '1px solid var(--line-1)' : 'none',
              borderBottom: '1px solid var(--line-1)',
              fontFamily: 'var(--mono)', fontSize: 10,
              color: 'var(--live)', letterSpacing: '0.1em',
            }}>[{r[0]}]</div>
          );
        }
        return (
          <div key={i} className="grid" style={{
            gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
            padding: '11px 16px',
            borderBottom: i < rows.length - 1 ? '1px solid var(--line-1)' : 'none',
            fontSize: 13, alignItems: 'center',
          }}>
            <div style={{ color: 'var(--fg-0)' }}>{r[0]}</div>
            {r.slice(1).map((c, j) => (
              <div key={j} className="mono" style={{
                fontSize: 12,
                color: c === '×' ? 'var(--fg-3)' : c === '✓' ? 'var(--live)' : 'var(--fg-1)',
              }}>{c}</div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

function FaqList() {
  const [open, setOpen] = React.useState(0);
  const items = [
    {
      q: '会议时长是怎么算的?',
      a: '从你点 ▷ start meeting 到 ⏹ end / pause 之间的真实秒数。Replay 不计时。 你可以随时暂停, 不用担心放着不管会被扣钱。',
    },
    {
      q: '托管模式 vs BYOK 怎么选?',
      a: '托管: 我们替你调 LLM, 价格透明 (上面的表), 适合不想管 API key、追求"插上就能用"的人。BYOK: 你接自己的 Anthropic / OpenAI / Google key, 我们只收 $5/月 平台费, 适合每月开会超过 50 场、想自己控成本的重度玩家。',
    },
    {
      q: '$30 / $50 LLM credits included 是什么意思?',
      a: '托管模式下, Pro 套餐每月送你 $30 LLM 用量, Team 每席位 $50。用完之后按上面公开费率继续花你的钱。BYOK 模式下没这一项, 因为你用的是自己的 key。',
    },
    {
      q: '为什么不按席位收钱?',
      a: '我们觉得"agent 越多越收你钱"是反激励 — 那会逼你用最少的角色开最浅的会。我们按时长收, 你随便加 agent, 反正慢思考的会是 agent 之间互相吵, 你就坐着看。',
    },
    {
      q: '可以随时降级 / 取消吗?',
      a: '可以。下个 billing cycle 生效, 当月已付的不退但可以用完。Enterprise 有合同条款单独谈。',
    },
    {
      q: '我的会议数据安全吗?',
      a: 'Pro 及以上加密存储, 默认仅你能看。Team 起 SSO + 审计日志。Enterprise 支持私有化部署 / VPC / 你自己的 LLM 网关 — 数据完全不出你的环境。',
    },
    {
      q: '学生 / 开源 / 非营利有折扣吗?',
      a: '有。学生用 .edu 邮箱注册自动 50% off Pro。 开源项目 maintainer 给你免费 Team。 非营利提供 50% Team 折扣。 写邮件给 hello@agentmeeting.dev。',
    },
  ];

  return (
    <div className="col gap-1" style={{
      border: '1px solid var(--line-2)', borderRadius: 6, overflow: 'hidden',
    }}>
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i} style={{
            borderBottom: i < items.length - 1 ? '1px solid var(--line-1)' : 'none',
            background: isOpen ? 'var(--bg-1)' : 'var(--bg-0)',
          }}>
            <div onClick={() => setOpen(isOpen ? -1 : i)} className="hov" style={{
              padding: '14px 18px', cursor: 'pointer',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <div className="flex gap-3" style={{ alignItems: 'center' }}>
                <span className="mono tiny" style={{ color: 'var(--live)' }}>
                  Q{String(i + 1).padStart(2, '0')}
                </span>
                <span style={{ fontWeight: 500 }}>{it.q}</span>
              </div>
              <span className="mono dim" style={{ fontSize: 14 }}>{isOpen ? '−' : '+'}</span>
            </div>
            {isOpen && (
              <div style={{
                padding: '0 18px 16px 56px',
                color: 'var(--fg-1)', fontSize: 13.5, lineHeight: 1.65,
              }}>{it.a}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
